/* Member Info Service
 *
 * This service is used to retrieve member information and should be the only gateway to member info from the AngularJS app
 * NOTE: The memberinfo cached data prefers the "extended" version and will cache/return that with priority over the "basic" version
 */
SUGApp.service('memberInfoService', ['sugCacheFactory', 'SUGUtilities', '$q', function (sugCacheFactory, util, $q) {
    var memberInfoService = this;

    /**
     * Verifys the memberinfo is valid
     * 
     * @param {Object} memberinfo - member info object to verify
     */
    var isValidMemberInfo = function (memberinfo) {
        return (!util.isUndefinedOrEmptyObject(memberinfo) && util.isIntegerGT0(memberinfo.memberid));
    };

    /**
     * Get Member Info - BASIC
     * 
     * @param {Boolean} forceRefresh - whether to forceably refresh the cache with data from the server
     */
    memberInfoService.getMemberInfo = function (extended,forceRefresh,listid,urlid) {
        // For some reason when calling this method from the tab group flow, the urlid is not being set from the parameter passed in. This is a fix for that by retrieving the value from the arguments scope of the array when this occurs and setting it.
        if (typeof urlid === 'undefined' && typeof arguments[0].urlid !== 'undefined') {
            urlid = arguments[0].urlid;
        }
        // get member info - cache result - return cache else go to the server
        var memberinfo = sugCacheFactory.get('memberinfoservice_memberinfo', {});
        if (!forceRefresh && isValidMemberInfo(memberinfo) && (!extended || (extended && util.keyExists(memberinfo, 'datetzsettings')))) {
            // deferring so this can be thenable
            var deferred = $q.defer();
            deferred.resolve(memberinfo);
            return deferred.promise;
        } else if(extended) {
            return util.APISyncCall('post', '', {
                'extendedinfo': true,
                'listid': typeof listid !== 'undefined' ? listid : 0,
                'urlid': typeof urlid !== 'undefined' ? urlid : ''
            }, 'm.getMemberInfo').then(function (response) {
                response = util.lowerCaseKeys(response.data);
                if (util.ajaxResultInvalid(response)) {
                    // invalid response, reject with error message
                    deferred.reject(util.resultErrorHandler(response.data));
                } else {
                    // cache the data
                    sugCacheFactory.set('memberinfoservice_memberinfo', response.data);
                    return response.data;
                }
            });
        } else {
            return util.APISyncCall('get', '', '', 'm.getMemberInfo').then(function (response) {
                response = util.lowerCaseKeys(response.data);
                if (util.ajaxResultInvalid(response)) {
                    // invalid response, reject with error message
                    deferred.reject(util.resultErrorHandler(response.data));
                } else {
                    // cache the data
                    sugCacheFactory.set('memberinfoservice_memberinfo', response.data);
                    return response.data;
                }
            });
        }
    };

}]);